import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router";
import { CONSTANTS_STRINGS } from "src/constants/strings";
import { Button } from "../ui/button";

interface BackButtonProps {
  disabled?: boolean;
}

const BackButton: React.FC<BackButtonProps> = ({ disabled = false }) => {
  const navigate = useNavigate();

  return (
    <Button
      variant={"outline"}
      size={"primary"}
      type="button"
      onClick={() => void navigate(-1)}
      disabled={disabled}
      className="w-13 cursor-pointer md:w-auto"
    >
      <ChevronLeft className="text-primary-1" />
      <span className="text-primary-1 hidden md:block">
        {CONSTANTS_STRINGS.CREDIT_CARD_BACK}
      </span>
    </Button>
  );
};

export default BackButton;
